"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateComponentLink = void 0;
exports.processSharedDRC = processSharedDRC;
const tslib_1 = require("tslib");
const reviews_1 = require("../reviews");
const converters_1 = require("./converters");
var converters_2 = require("./converters");
Object.defineProperty(exports, "generateComponentLink", { enumerable: true, get: function () { return converters_2.generateComponentLink; } });
function convertProblemToReviewCheck(documentUid, inProgress, reviewType, problems, _validator, reviewsByUid, toItemFromProblem) {
    const review = reviews_1.reviewData[reviewType];
    const reviewUid = `rev_${review.type}`;
    const reviewChecks = problems.map((problem, index) => {
        const { status = reviews_1.ReviewStatus.ERROR, designatorUidMap, ...item } = toItemFromProblem(problem);
        const ids = problem?.affectedItems?.map((item) => item.uid) ?? (item.name ? [item.name] : []);
        const reviewCheckUid = (0, reviews_1.createDRCCheckId)(reviewType, ids);
        const reviewCheck = reviewsByUid[reviewUid]?.checks[reviewCheckUid];
        const reviewCheckItem = {
            uid: reviewCheckUid,
            reviewUid,
            documentUid,
            assignedStatus: reviewCheck?.assignedStatus,
            name: item.name ?? "",
            index: index,
            status,
            link: (0, converters_1.generateComponentLink)(item.name ?? ""),
            description: review.description,
            data: { problem, ...item },
            designatorUidMap,
        };
        return [reviewCheckUid, reviewCheckItem];
    });
    const checks = Object.fromEntries(reviewChecks);
    const status = inProgress
        ? reviews_1.ReviewStatus.RUNNING
        : problems.length
            ? (0, reviews_1.aggregateReviewStatus)(Object.values(checks).map((check) => check.status))
            : reviews_1.ReviewStatus.SUCCESS;
    return {
        ...review,
        uid: reviewUid,
        documentUid,
        status,
        assignedStatus: reviewsByUid[reviewUid]?.assignedStatus,
        columns: Object.fromEntries(Object.keys(review.columns).map((key) => [key, { ...review.columns[key], uid: key }])),
        checks,
    };
}
function processSharedDRC(input) {
    const { documentUid, detectedProblems, checksInProgress, validators, nodes, pcbLayoutRuleSets, reviewsByUid, showHiddenChecks, } = input;
    const drcReviews = validators
        .map((validator) => {
        const problems = Object.values(detectedProblems).filter((problem) => problem.problemTypeKey === validator.problemTypeKey);
        // Skip validators that are hidden by default and have no problems (unless showHiddenChecks is enabled)
        if (!showHiddenChecks && validator.defaultHidden && problems.length === 0) {
            return undefined;
        }
        const isCheckInProgress = checksInProgress[validator.problemTypeKey] ?? false;
        // Use validator.reviewType directly - no string concatenation magic
        switch (validator.reviewType) {
            case reviews_1.ReviewType.DesignRuleCheckAirwire: {
                const { sortedProblems, converter } = (0, converters_1.sortAirwireProblems)(problems, nodes);
                return convertProblemToReviewCheck(documentUid, isCheckInProgress, reviews_1.ReviewType.DesignRuleCheckAirwire, sortedProblems, validator, reviewsByUid, converter);
            }
            case reviews_1.ReviewType.DesignRuleCheckFloatingCopper:
                return convertProblemToReviewCheck(documentUid, isCheckInProgress, reviews_1.ReviewType.DesignRuleCheckFloatingCopper, problems, validator, reviewsByUid, (0, converters_1.convertFloatingCopperResultToReview)(nodes));
            case reviews_1.ReviewType.DesignRuleCheckOverlappingCopper: {
                const { sortedProblems, converter } = (0, converters_1.sortOverlappingCopperProblems)(problems, nodes);
                return convertProblemToReviewCheck(documentUid, isCheckInProgress, reviews_1.ReviewType.DesignRuleCheckOverlappingCopper, sortedProblems, validator, reviewsByUid, converter);
            }
            case reviews_1.ReviewType.DesignRuleCheckComponentOverrides: {
                const { sortedProblems, converter } = (0, converters_1.sortComponentOverrideProblems)(problems, nodes, pcbLayoutRuleSets);
                return convertProblemToReviewCheck(documentUid, isCheckInProgress, reviews_1.ReviewType.DesignRuleCheckComponentOverrides, sortedProblems, validator, reviewsByUid, converter);
            }
            case reviews_1.ReviewType.DesignRuleCheckInvalidLayer:
                return convertProblemToReviewCheck(documentUid, isCheckInProgress, reviews_1.ReviewType.DesignRuleCheckInvalidLayer, problems, validator, reviewsByUid, (0, converters_1.convertInvalidLayer)(nodes));
            case reviews_1.ReviewType.DesignRuleCheckOverlappingFills:
                return convertProblemToReviewCheck(documentUid, isCheckInProgress, reviews_1.ReviewType.DesignRuleCheckOverlappingFills, problems, validator, reviewsByUid, (0, converters_1.convertOverlappingFills)(nodes));
            case reviews_1.ReviewType.DesignRuleCheckDeprecatedRules:
                return convertProblemToReviewCheck(documentUid, isCheckInProgress, reviews_1.ReviewType.DesignRuleCheckDeprecatedRules, (0, converters_1.splitDeprecatedRuleProblems)(problems), validator, reviewsByUid, (0, converters_1.convertDeprecatedRules)(nodes, pcbLayoutRuleSets));
            case reviews_1.ReviewType.DesignRuleCheckTraceCornerRadius:
                return convertProblemToReviewCheck(documentUid, isCheckInProgress, reviews_1.ReviewType.DesignRuleCheckTraceCornerRadius, problems, validator, reviewsByUid, (0, converters_1.convertTraceCornerRadius)(nodes));
            case reviews_1.ReviewType.DesignRuleCheckProtectedIntrusions:
                return convertProblemToReviewCheck(documentUid, isCheckInProgress, reviews_1.ReviewType.DesignRuleCheckProtectedIntrusions, problems, validator, reviewsByUid, (0, converters_1.convertProtectedIntrusions)(nodes));
        }
    })
        .filter(Boolean);
    const isAnyCheckInProgress = Object.values(checksInProgress).some(Boolean);
    return {
        name: reviews_1.ReviewCategoryType.DesignRuleChecks,
        status: isAnyCheckInProgress
            ? reviews_1.ReviewStatus.RUNNING
            : !drcReviews.length
                ? reviews_1.ReviewStatus.OPEN
                : (0, reviews_1.aggregateReviewStatus)(drcReviews.map((review) => review.assignedStatus ?? review.status)),
        reviews: drcReviews,
    };
}
tslib_1.__exportStar(require("./converters"), exports);
//# sourceMappingURL=sharedDRCProcessor.js.map